import setupObserver from './observer';

const SELECTOR = '.image--lazy, .js-lazy-load';

function showImage(target) {
  // we may be an img or a picture with sources and images inside
  [target].concat(Array.from(target.querySelectorAll('source, img'))).forEach((image) => {
    ['src', 'srcset'].forEach((prop) => {
      if (image.hasAttribute(`data-${prop}`)) {
        image.setAttribute(prop, image.getAttribute(`data-${prop}`));
        image.removeAttribute(`data-${prop}`);
      }
    });
  });
}

/**
 * Given a NodeList of images, maps them to PICTURE tags for any images that are
 * inside a picture, and for all others returns just the image
 */
const imagesAndPictures = (images) => (
  Array.from(images).map((image) => (
    image.parentNode.tagName === 'PICTURE' ? image.parentNode : image
  ))
);

/**
 * Given an NodeList of images, sets them up to be lazy-loaded
 */
export default function setupLazyImages(images = document.querySelectorAll(SELECTOR)) {
  const elements = imagesAndPictures(images);
  setupObserver(elements, showImage);
}
